const supportedLanguages = [
  { code: 'english', value: 'English' },
  { code: 'russian', value: 'Русский' },
  { code: 'belarusian', value: 'Беларуская' }
];

export { supportedLanguages };
